export enum AppointmentStatus {
	REQUEST = 'REQUEST',
	ACCEPTED = 'ACCEPTED',
	REJECTED = 'REJECTED',
}
